export default "__VITE_ASSET__BoBiKr3H__"